(function () {
    const heros = document.querySelectorAll('.js-hero');

    [].forEach.call(heros, hero => {
        const buttonGroup = hero.querySelector('.js-hero-button-group');
        const primaryButton = hero.querySelector('.js-hero-button-primary');
        if (!buttonGroup || !primaryButton || !primaryButton.href) {
            return;
        }

        hero.addEventListener('click', e => {
            const clickedElement = e.target;
            if (buttonGroup.contains(clickedElement)) {
                return;
            }
            window.location = primaryButton.href;
        })
    });
})()